import { render } from "./UserPanel.vue?vue&type=template&id=6cfdcc53&scoped=true&ts=true"
import script from "./UserPanel.vue?vue&type=script&lang=ts"
export * from "./UserPanel.vue?vue&type=script&lang=ts"

import "./UserPanel.vue?vue&type=style&index=0&id=6cfdcc53&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfdcc53"]])

export default __exports__